import { useState, useRef } from "react";
import "@/App.css";
import { Phone, Mail, MapPin, Car, FileText, CreditCard, RefreshCw, Wrench, X, ChevronDown, Calendar, Gauge, Fuel, Calculator, Search, SlidersHorizontal } from "lucide-react";

const cars = [
  {
    id: 1,
    name: "Volkswagen Polo",
    year: 2021,
    km: 28000,
    fuel: "Benzina",
    price: 16500,
    image: "https://images.unsplash.com/photo-1662114807919-ce048d2ea7a7?w=800",
    description: "Volkswagen Polo in ottime condizioni, tagliandi regolari, unico proprietario. Dotata di climatizzatore, sensori di parcheggio, bluetooth e cruise control.",
    brand: "Volkswagen",
    transmission: "Manuale",
    hp: 95,
    color: "Argento"
  },
  {
    id: 2,
    name: "Volkswagen Beetle",
    year: 2019,
    km: 45000,
    fuel: "Benzina",
    price: 18200,
    image: "https://images.unsplash.com/photo-1626115171991-bd19a787daf0?w=800",
    description: "Iconico Beetle in versione moderna, perfetto stato, interni in pelle. Tetto apribile, navigatore, sedili riscaldati.",
    brand: "Volkswagen",
    transmission: "Automatica",
    hp: 105,
    color: "Arancione"
  },
  {
    id: 3,
    name: "Volkswagen Passat",
    year: 2020,
    km: 52000,
    fuel: "Diesel",
    price: 21500,
    image: "https://images.unsplash.com/photo-1762028159058-5e0b9d52c836?w=800",
    description: "Passat berlina, motore 2.0 TDI efficiente e potente. Full optional con ACC, Lane Assist, fari LED Matrix.",
    brand: "Volkswagen",
    transmission: "Automatica",
    hp: 150,
    color: "Blu Scuro"
  },
  {
    id: 4,
    name: "Toyota RAV4",
    year: 2021,
    km: 38000,
    fuel: "Ibrida",
    price: 26800,
    image: "https://images.unsplash.com/photo-1617600346256-af3cd5b16a4d?w=800",
    description: "SUV ibrido con consumi ridotti, spazio e comfort. AWD, telecamera 360, Toyota Safety Sense completo.",
    brand: "Toyota",
    transmission: "Automatica",
    hp: 218,
    color: "Bianco"
  },
  {
    id: 5,
    name: "Toyota Yaris",
    year: 2022,
    km: 22000,
    fuel: "Ibrida",
    price: 15900,
    image: "https://images.unsplash.com/photo-1685783230651-fbc5382054e1?w=800",
    description: "Yaris Hybrid di ultima generazione, consumi eccezionali. Apple CarPlay, Android Auto, frenata automatica.",
    brand: "Toyota",
    transmission: "Automatica",
    hp: 116,
    color: "Rosso"
  },
  {
    id: 6,
    name: "Toyota Camry",
    year: 2020,
    km: 48000,
    fuel: "Ibrida",
    price: 23400,
    image: "https://images.pexels.com/photos/11285174/pexels-photo-11285174.jpeg?auto=compress&cs=tinysrgb&w=800",
    description: "Berlina elegante e spaziosa, tecnologia ibrida affidabile. Interni premium, JBL audio system, head-up display.",
    brand: "Toyota",
    transmission: "Automatica",
    hp: 178,
    color: "Bianco"
  },
  {
    id: 7,
    name: "Fiat 500X",
    year: 2021,
    km: 32000,
    fuel: "Benzina",
    price: 17800,
    image: "https://images.unsplash.com/photo-1694264736944-0bb6befb68be?w=800",
    description: "Crossover italiano dal design unico, pratico e versatile. Uconnect 7\", sensori parcheggio anteriori e posteriori.",
    brand: "Fiat",
    transmission: "Manuale",
    hp: 120,
    color: "Nero"
  },
  {
    id: 8,
    name: "Renault Clio",
    year: 2022,
    km: 18000,
    fuel: "Benzina",
    price: 14500,
    image: "https://images.unsplash.com/photo-1698267011298-db52f41a0241?w=800",
    description: "Nuova Clio con design moderno e tecnologie avanzate. Easy Link multimedia, fari full LED, guida assistita.",
    brand: "Renault",
    transmission: "Manuale",
    hp: 100,
    color: "Bianco"
  },
  {
    id: 9,
    name: "Ford Focus",
    year: 2020,
    km: 44000,
    fuel: "Diesel",
    price: 16900,
    image: "https://images.unsplash.com/photo-1558787503-311fdac114af?w=800",
    description: "Focus station wagon, perfetta per famiglia e lavoro. SYNC 3, Co-Pilot360, portellone elettrico.",
    brand: "Ford",
    transmission: "Manuale",
    hp: 120,
    color: "Nero"
  }
];

const featuredCar = {
  id: 0,
  name: "Volkswagen Golf 8",
  year: 2022,
  km: 35000,
  fuel: "Benzina",
  price: 22500,
  image: "https://images.unsplash.com/photo-1665411767657-f72503c1f557?w=800",
  description: "Golf 8 ultimo modello con tecnologia all'avanguardia. Digital Cockpit, IQ.Light, Travel Assist. Auto in condizioni impeccabili.",
  brand: "Volkswagen",
  transmission: "Automatica",
  hp: 150,
  color: "Nero"
};

const services = [
  { icon: Car, title: "Vendita Auto", desc: "Ampia selezione di auto nuove e usate di qualita certificata" },
  { icon: FileText, title: "Import Auto", desc: "Importazione di veicoli dall'estero con garanzia e assistenza completa" },
  { icon: CreditCard, title: "Finanziamenti", desc: "Soluzioni di finanziamento personalizzate e convenienti" },
  { icon: RefreshCw, title: "Permuta", desc: "Valutiamo la tua auto usata per la permuta con il nuovo acquisto" },
  { icon: Wrench, title: "Assistenza", desc: "Servizio di assistenza e manutenzione post-vendita professionale" }
];

const WhatsAppIcon = ({ size = 20 }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
  </svg>
);

function App() {
  const [selectedCar, setSelectedCar] = useState(null);
  const [filters, setFilters] = useState({ brand: "", fuel: "", maxPrice: 50000, minYear: 2018, maxKm: 60000, transmission: "", sortBy: "price-asc" });
  const [financeCalc, setFinanceCalc] = useState({ price: 20000, downPayment: 3000, months: 48, rate: 5.9 });
  
  const heroRef = useRef(null);
  const featuredRef = useRef(null);
  const inventoryRef = useRef(null);
  const servicesRef = useRef(null);
  const financeRef = useRef(null);
  const contactRef = useRef(null);

  const scrollToSection = (ref) => {
    ref.current?.scrollIntoView({ behavior: "smooth" });
  };

  const filteredCars = cars
    .filter(car => {
      if (filters.brand && car.brand !== filters.brand) return false;
      if (filters.fuel && car.fuel !== filters.fuel) return false;
      if (filters.transmission && car.transmission !== filters.transmission) return false;
      if (car.price > filters.maxPrice) return false;
      if (car.year < filters.minYear) return false;
      if (car.km > filters.maxKm) return false;
      return true;
    })
    .sort((a, b) => {
      switch (filters.sortBy) {
        case "price-asc": return a.price - b.price;
        case "price-desc": return b.price - a.price;
        case "year-desc": return b.year - a.year;
        case "km-asc": return a.km - b.km;
        default: return 0;
      }
    });

  const resetFilters = () => {
    setFilters({ brand: "", fuel: "", maxPrice: 50000, minYear: 2018, maxKm: 60000, transmission: "", sortBy: "price-asc" });
  };

  // Finance calculator
  const loanAmount = financeCalc.price - financeCalc.downPayment;
  const monthlyRate = financeCalc.rate / 100 / 12;
  const monthlyPayment = monthlyRate > 0
    ? (loanAmount * monthlyRate * Math.pow(1 + monthlyRate, financeCalc.months)) / (Math.pow(1 + monthlyRate, financeCalc.months) - 1)
    : loanAmount / financeCalc.months;
  const totalPayment = monthlyPayment * financeCalc.months;
  const totalInterest = totalPayment - loanAmount;

  const openWhatsApp = () => {
    window.open("https://wa.me/393356158159", "_blank");
  };

  const callPhone = () => {
    window.location.href = "tel:+393356158159";
  };

  const sendEmail = () => {
    window.location.href = "mailto:stefanoranieri31@gmail.com";
  };

  const openFinanceForCar = (car) => {
    setFinanceCalc({ ...financeCalc, price: car.price, downPayment: Math.round(car.price * 0.2) });
    setSelectedCar(null);
    setTimeout(() => scrollToSection(financeRef), 100);
  };

  return (
    <div className="app">
      {/* Banner Allestimento */}
      <div className="construction-banner" data-testid="construction-banner">
        SITO IN ALLESTIMENTO
      </div>

      {/* Navigation */}
      <nav className="navbar">
        <div className="nav-container">
          <div className="logo" onClick={() => scrollToSection(heroRef)} data-testid="logo">
            SRCARS
          </div>
          <div className="nav-links">
            <button onClick={() => scrollToSection(featuredRef)} className="nav-link" data-testid="nav-featured">
              In Evidenza
            </button>
            <button onClick={() => scrollToSection(inventoryRef)} className="nav-link" data-testid="nav-inventory">
              Inventario
            </button>
            <button onClick={() => scrollToSection(financeRef)} className="nav-link" data-testid="nav-finance">
              Finanziamento
            </button>
            <button onClick={() => scrollToSection(servicesRef)} className="nav-link" data-testid="nav-services">
              Servizi
            </button>
            <button onClick={() => scrollToSection(contactRef)} className="nav-link" data-testid="nav-contact">
              Contatti
            </button>
            <button onClick={openWhatsApp} className="nav-cta" data-testid="nav-whatsapp">
              <Phone size={16} />
              Contatta Ora
            </button>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="hero" ref={heroRef}>
        <div className="hero-bg">
          <img src="https://images.unsplash.com/photo-1629885389996-c149c822392f?w=1600" alt="Auto" />
          <div className="hero-overlay"></div>
        </div>
        <div className="hero-content">
          <h1 className="hero-title">SRCARS</h1>
          <p className="hero-subtitle">Auto selezionate, qualita garantita</p>
          <button onClick={() => scrollToSection(inventoryRef)} className="hero-btn" data-testid="hero-cta">
            Scopri le Auto
          </button>
        </div>
        <div className="scroll-indicator" onClick={() => scrollToSection(featuredRef)}>
          <ChevronDown size={32} />
        </div>
      </section>

      {/* Featured Section */}
      <section className="featured" ref={featuredRef}>
        <h2 className="section-title">Auto in Evidenza</h2>
        <div className="featured-card" onClick={() => setSelectedCar(featuredCar)} data-testid="featured-car">
          <div className="featured-image">
            <img src={featuredCar.image} alt={featuredCar.name} />
          </div>
          <div className="featured-info">
            <h3>{featuredCar.name}</h3>
            <div className="car-specs">
              <span><Calendar size={14} /> {featuredCar.year}</span>
              <span><Gauge size={14} /> {featuredCar.km.toLocaleString()} km</span>
              <span><Fuel size={14} /> {featuredCar.fuel}</span>
            </div>
            <p className="car-price">&euro; {featuredCar.price.toLocaleString()}</p>
            <button className="details-btn" data-testid="featured-details-btn">Scopri di Piu</button>
          </div>
        </div>
      </section>

      {/* Inventory Section */}
      <section className="inventory" ref={inventoryRef}>
        <h2 className="section-title">Auto in Vendita</h2>
        <p className="section-subtitle">Esplora la nostra selezione di veicoli di qualita certificata</p>
        
        {/* Enhanced Filters */}
        <div className="filters" data-testid="filters-section">
          <div className="filters-header">
            <h3><SlidersHorizontal size={20} /> Filtra Ricerca</h3>
            <button className="reset-filters-btn" onClick={resetFilters} data-testid="reset-filters">
              Resetta Filtri
            </button>
          </div>
          <div className="filter-group">
            <div className="filter-item">
              <label>Marca</label>
              <select 
                value={filters.brand} 
                onChange={(e) => setFilters({...filters, brand: e.target.value})}
                data-testid="filter-brand"
              >
                <option value="">Tutte le Marche</option>
                <option value="Volkswagen">Volkswagen</option>
                <option value="Toyota">Toyota</option>
                <option value="Fiat">Fiat</option>
                <option value="Renault">Renault</option>
                <option value="Ford">Ford</option>
              </select>
            </div>
            
            <div className="filter-item">
              <label>Alimentazione</label>
              <select 
                value={filters.fuel} 
                onChange={(e) => setFilters({...filters, fuel: e.target.value})}
                data-testid="filter-fuel"
              >
                <option value="">Tutti i Tipi</option>
                <option value="Benzina">Benzina</option>
                <option value="Diesel">Diesel</option>
                <option value="Ibrida">Ibrida</option>
              </select>
            </div>

            <div className="filter-item">
              <label>Cambio</label>
              <select 
                value={filters.transmission} 
                onChange={(e) => setFilters({...filters, transmission: e.target.value})}
                data-testid="filter-transmission"
              >
                <option value="">Tutti</option>
                <option value="Manuale">Manuale</option>
                <option value="Automatica">Automatica</option>
              </select>
            </div>

            <div className="filter-item">
              <label>Ordina Per</label>
              <select 
                value={filters.sortBy} 
                onChange={(e) => setFilters({...filters, sortBy: e.target.value})}
                data-testid="filter-sort"
              >
                <option value="price-asc">Prezzo Crescente</option>
                <option value="price-desc">Prezzo Decrescente</option>
                <option value="year-desc">Piu Recenti</option>
                <option value="km-asc">Meno Km</option>
              </select>
            </div>
          </div>

          <div className="filter-sliders">
            <div className="slider-item">
              <label>Prezzo Massimo: &euro; {filters.maxPrice.toLocaleString()}</label>
              <input 
                type="range" min="10000" max="50000" step="1000"
                value={filters.maxPrice}
                onChange={(e) => setFilters({...filters, maxPrice: parseInt(e.target.value)})}
                data-testid="filter-price"
              />
            </div>
            <div className="slider-item">
              <label>Anno Minimo: {filters.minYear}</label>
              <input 
                type="range" min="2015" max="2024" step="1"
                value={filters.minYear}
                onChange={(e) => setFilters({...filters, minYear: parseInt(e.target.value)})}
                data-testid="filter-year"
              />
            </div>
            <div className="slider-item">
              <label>Km Massimi: {filters.maxKm.toLocaleString()} km</label>
              <input 
                type="range" min="10000" max="100000" step="5000"
                value={filters.maxKm}
                onChange={(e) => setFilters({...filters, maxKm: parseInt(e.target.value)})}
                data-testid="filter-km"
              />
            </div>
          </div>

          <div className="filter-results">
            <Search size={16} />
            <span>{filteredCars.length} auto trovate</span>
          </div>
        </div>

        {/* Car Grid */}
        <div className="car-grid">
          {filteredCars.map(car => (
            <div key={car.id} className="car-card" onClick={() => setSelectedCar(car)} data-testid={`car-card-${car.id}`}>
              <div className="car-image">
                <img src={car.image} alt={car.name} />
                <span className="car-badge">{car.fuel}</span>
              </div>
              <div className="car-info">
                <h3>{car.name}</h3>
                <div className="car-details">
                  <div className="detail">
                    <span className="label">Anno</span>
                    <span className="value">{car.year}</span>
                  </div>
                  <div className="detail">
                    <span className="label">Km</span>
                    <span className="value">{car.km.toLocaleString()}</span>
                  </div>
                  <div className="detail">
                    <span className="label">Cambio</span>
                    <span className="value">{car.transmission}</span>
                  </div>
                </div>
                <p className="car-price">&euro; {car.price.toLocaleString()}</p>
                <button className="details-btn" data-testid={`details-btn-${car.id}`}>Maggiori Dettagli</button>
              </div>
            </div>
          ))}
          {filteredCars.length === 0 && (
            <div className="no-results" data-testid="no-results">
              <p>Nessuna auto trovata con i filtri selezionati.</p>
              <button onClick={resetFilters} className="details-btn">Resetta Filtri</button>
            </div>
          )}
        </div>
      </section>

      {/* Finance Calculator Section */}
      <section className="finance" ref={financeRef}>
        <h2 className="section-title">Calcola il Tuo Finanziamento</h2>
        <p className="section-subtitle">Simula le rate per l'acquisto della tua prossima auto</p>
        
        <div className="finance-container" data-testid="finance-calculator">
          <div className="finance-inputs">
            <h3><Calculator size={20} /> Parametri del Finanziamento</h3>
            <div className="finance-field">
              <label>Prezzo dell'auto (&euro;)</label>
              <input 
                type="number" min="5000" max="100000" step="500"
                value={financeCalc.price}
                onChange={(e) => setFinanceCalc({...financeCalc, price: parseInt(e.target.value) || 0})}
                data-testid="finance-price"
              />
            </div>
            <div className="finance-field">
              <label>Anticipo (&euro;)</label>
              <input 
                type="number" min="0" max={financeCalc.price} step="500"
                value={financeCalc.downPayment}
                onChange={(e) => setFinanceCalc({...financeCalc, downPayment: parseInt(e.target.value) || 0})}
                data-testid="finance-down"
              />
            </div>
            <div className="finance-field">
              <label>Durata (mesi)</label>
              <select 
                value={financeCalc.months}
                onChange={(e) => setFinanceCalc({...financeCalc, months: parseInt(e.target.value)})}
                data-testid="finance-months"
              >
                <option value={12}>12 mesi</option>
                <option value={24}>24 mesi</option>
                <option value={36}>36 mesi</option>
                <option value={48}>48 mesi</option>
                <option value={60}>60 mesi</option>
                <option value={72}>72 mesi</option>
                <option value={84}>84 mesi</option>
              </select>
            </div>
            <div className="finance-field">
              <label>Tasso Annuo (%)</label>
              <input 
                type="number" min="0" max="20" step="0.1"
                value={financeCalc.rate}
                onChange={(e) => setFinanceCalc({...financeCalc, rate: parseFloat(e.target.value) || 0})}
                data-testid="finance-rate"
              />
            </div>
          </div>

          <div className="finance-results">
            <h3>Riepilogo Rate</h3>
            <div className="finance-summary">
              <div className="finance-row">
                <span>Prezzo auto</span>
                <span>&euro; {financeCalc.price.toLocaleString()}</span>
              </div>
              <div className="finance-row">
                <span>Anticipo</span>
                <span>- &euro; {financeCalc.downPayment.toLocaleString()}</span>
              </div>
              <div className="finance-row highlight">
                <span>Importo finanziato</span>
                <span>&euro; {loanAmount.toLocaleString()}</span>
              </div>
              <div className="finance-row">
                <span>Tasso annuo</span>
                <span>{financeCalc.rate}%</span>
              </div>
              <div className="finance-row">
                <span>Numero rate</span>
                <span>{financeCalc.months} mesi</span>
              </div>
              <div className="finance-divider"></div>
              <div className="finance-row monthly">
                <span>Rata Mensile</span>
                <span>&euro; {monthlyPayment.toFixed(2)}</span>
              </div>
              <div className="finance-row">
                <span>Totale interessi</span>
                <span>&euro; {totalInterest.toFixed(2)}</span>
              </div>
              <div className="finance-row highlight">
                <span>Totale da pagare</span>
                <span>&euro; {totalPayment.toFixed(2)}</span>
              </div>
            </div>
            <button onClick={openWhatsApp} className="finance-cta" data-testid="finance-whatsapp">
              <WhatsAppIcon size={18} />
              Richiedi Finanziamento su WhatsApp
            </button>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="services" ref={servicesRef}>
        <h2 className="section-title">I Nostri Servizi</h2>
        <p className="section-subtitle">Soluzioni complete per ogni esigenza automobilistica</p>
        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card" data-testid={`service-${index}`}>
              <div className="service-icon">
                <service.icon size={32} />
              </div>
              <h3>{service.title}</h3>
              <p>{service.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Contact Section */}
      <section className="contact" ref={contactRef}>
        <h2 className="section-title">Contattaci</h2>
        <p className="section-subtitle">Siamo qui per aiutarti a trovare l'auto perfetta</p>
        <div className="contact-grid">
          <div className="contact-info">
            <div className="contact-item">
              <MapPin size={24} />
              <div>
                <h4>Indirizzo</h4>
                <p>Via Ponte Mammolo 28</p>
                <p>Roma, Italia</p>
              </div>
            </div>
            <div className="contact-item" onClick={callPhone} style={{cursor: 'pointer'}} data-testid="contact-phone">
              <Phone size={24} />
              <div>
                <h4>Telefono</h4>
                <p>335 615 8159</p>
              </div>
            </div>
            <div className="contact-item" onClick={sendEmail} style={{cursor: 'pointer'}} data-testid="contact-email">
              <Mail size={24} />
              <div>
                <h4>Email</h4>
                <p>stefanoranieri31@gmail.com</p>
              </div>
            </div>
          </div>
          <div className="contact-buttons">
            <button onClick={callPhone} className="contact-btn phone-btn" data-testid="call-btn">
              <Phone size={20} />
              Chiama Ora
            </button>
            <button onClick={openWhatsApp} className="contact-btn whatsapp-btn" data-testid="whatsapp-btn">
              <WhatsAppIcon />
              WhatsApp
            </button>
          </div>
        </div>

        {/* Google Maps */}
        <div className="map-container" data-testid="map">
          <iframe 
            title="SRCARS Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2970.123!2d12.5719!3d41.9167!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x132f61b8e2e7c1d1%3A0x0!2sVia+Ponte+Mammolo+28%2C+Roma!5e0!3m2!1sit!2sit!4v1700000000000"
            width="100%" 
            height="400" 
            style={{border: 0, borderRadius: '16px'}} 
            allowFullScreen="" 
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <p>&copy; 2024 SRCARS - Tutti i diritti riservati</p>
      </footer>

      {/* Car Detail Modal */}
      {selectedCar && (
        <div className="modal-overlay" onClick={() => setSelectedCar(null)} data-testid="modal-overlay">
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setSelectedCar(null)} data-testid="modal-close">
              <X size={24} />
            </button>
            <div className="modal-image">
              <img src={selectedCar.image} alt={selectedCar.name} />
            </div>
            <div className="modal-content">
              <h2>{selectedCar.name}</h2>
              <p className="modal-price">&euro; {selectedCar.price.toLocaleString()}</p>
              <div className="modal-specs">
                <div className="spec">
                  <Calendar size={18} />
                  <span>Anno: {selectedCar.year}</span>
                </div>
                <div className="spec">
                  <Gauge size={18} />
                  <span>{selectedCar.km.toLocaleString()} km</span>
                </div>
                <div className="spec">
                  <Fuel size={18} />
                  <span>{selectedCar.fuel}</span>
                </div>
              </div>
              <div className="modal-extra-specs">
                <div className="extra-spec"><span>Cambio:</span> {selectedCar.transmission}</div>
                <div className="extra-spec"><span>Potenza:</span> {selectedCar.hp} CV</div>
                <div className="extra-spec"><span>Colore:</span> {selectedCar.color}</div>
              </div>
              <p className="modal-description">{selectedCar.description}</p>
              <div className="modal-actions">
                <button onClick={openWhatsApp} className="modal-btn whatsapp" data-testid="modal-whatsapp">
                  <WhatsAppIcon size={18} />
                  Contatta su WhatsApp
                </button>
                <button onClick={callPhone} className="modal-btn call" data-testid="modal-call">
                  <Phone size={18} />
                  Chiama
                </button>
              </div>
              <button onClick={() => openFinanceForCar(selectedCar)} className="modal-finance-btn" data-testid="modal-finance">
                <Calculator size={18} />
                Calcola Rata per questa auto
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
